import { useNavbar } from 'app/Provider/NavbarProvider';
import { Form, Formik } from 'formik';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import info from 'app/components/VacationPlanner/assests/info.svg';
import Goal from 'app/components/VacationPlanner/assests/goal 4.svg';
import { InvestmentPieChart } from '../PieChart';
import { useGoalPlanner } from 'app/Provider/GoalPlannerProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useGoalSlice } from '../GoalPlannerCard/slice';
import { selectGoal } from '../GoalPlannerCard/slice/selectors';
import { CongratsComponent } from '../CongratsComponent';
import pic5 from 'app/components/VacationPlan/assests/Group-6.svg';

import pic1 from 'app/components/VacationPlan/assests/Vector.svg';
import pic2 from 'app/components/VacationPlan/assests/Vector-2.svg';
import { VacationAdvance } from '../VacationAdvance';

interface Props {}

export const Vacation = memo((props: Props) => {
  const {
    toggleModal,
    vacation,
    advanceVacationData,
    setvacationAmount,
    switchMode,
    setMode,
    setswitch,
    setvacationDuration,
    setvacationreturns,
    monthlySavings,
  } = useGoalPlanner();
  const navigate = useNavigate();
  const { showNavbar, hideNavbar } = useNavbar();
  const dispatch = useDispatch();
  const { actions } = useGoalSlice();
  const { createGoalSuccessResponse } = useSelector(selectGoal);
  const [selected, setSelected] = useState('');
  const [Show, setShow] = useState(true);
  const [openScenario, setOpenScenario] = useState(false);
  const [timeExtend, setTimeExtend] = useState('');
  const [returnExtend, setReturnExtend] = useState('');
  const [budgetExtend, setBudgetExtend] = useState('');
  const [inflation, setInflation] = useState('');
  const [scenarioOne, setScenarioOne] = useState(false);
  const [scenarioTwo, setScenarioTwo] = useState(false);
  const [scenarioThree, setScenarioThree] = useState(false);
  const [scenarioFour, setScenarioFour] = useState(false);
  const formRef = useRef<any>();
  const FormRef = useRef<any>();
  const [graphValue, setGraphValue] = useState(0);
  const [showCongrats, setShowCongrats] = useState(false);
  const [once, setOnce] = useState(true);
  const [id, setId] = useState('');
  useEffect(() => {
    if (createGoalSuccessResponse) {
      setShowCongrats(true);
      setId(createGoalSuccessResponse.id);
      toggleModal();
      dispatch(actions.responsenull());
    }
  }, [createGoalSuccessResponse, dispatch, actions, toggleModal]);

  useEffect(() => {
    if (once) {
      setMode();
      setOnce(false);
    }
  }, [setMode, once]);
  useEffect(() => {
    setShowCongrats(false);
  }, [switchMode]);
  useEffect(() => {
    let uValue = parseFloat(vacation.budget);

    if (scenarioOne) {
      const percentage = parseFloat(inflation.replace('%', ''));
      const addvalue = (percentage / 100) * uValue;
      uValue = uValue + addvalue;
      setGraphValue(Math.round(uValue * 100) / 100);
    }

    if (scenarioFour) {
      const budgetExtValue = parseFloat(budgetExtend.substring(1));
      if (budgetExtValue > uValue) {
        setGraphValue(0);
      } else {
        setGraphValue(Math.round((uValue - budgetExtValue) * 100) / 100);
      }
    }

    if (!scenarioOne && !scenarioFour) {
      setGraphValue(Math.round(parseFloat(vacation.budget) * 100) / 100);
    }
  }, [scenarioOne, scenarioFour, inflation, budgetExtend, vacation.budget]);
  function getCurrentTimestamp() {
    const now = new Date();
    return now.toISOString().split('.')[0] + 'Z';
  }

  const createTargetDate = (yearsToAdd: number): string => {
    const currentDate = new Date();
    const targetDate = new Date(
      currentDate.getFullYear() + yearsToAdd,
      currentDate.getMonth(),
      currentDate.getDate(),
    );

    // Set time to midnight UTC
    targetDate.setUTCHours(0, 0, 0, 0);

    return targetDate.toISOString();
  };
  const basicSubmit = values => {
    const payload = {
      name: 'vacation plan',
      description: 'vacation plan',
      start_date: getCurrentTimestamp(),
      opening_amount: 0,
      target_amount: parseFloat(vacation.budget),
      target_date: createTargetDate(Number(values.years)),
      type: 'save_up',
      contribution_frequency: 'monthly',
      metadata: {
        monthlysavings: monthlySavings,
      },
      purpose: 'travel',
    };
    dispatch(actions.createGoal(payload));
  };
  const AdvanceSubmit = values => {
    if (createGoalSuccessResponse) {
      const payload = {
        id: createGoalSuccessResponse.id,
        name: 'vacation plan',
        description: 'vacation plan',
        start_date: getCurrentTimestamp(),
        opening_amount: 0,
        target_amount: parseFloat(advanceVacationData.amount),
        target_date: createTargetDate(values.years),
        type: 'save_up',
        contribution_frequency: 'monthly',
        metadata: {
          values,
          monthlysavings: monthlySavings,
        },
        purpose: 'travel',
      };
      dispatch(actions.createGoal(payload));
    } else {
      const payload = {
        name: 'vacation plan',
        description: 'vacation plan',
        start_date: getCurrentTimestamp(),
        opening_amount: 0,
        target_amount: parseFloat(advanceVacationData.amount),
        target_date: createTargetDate(Number(values.years)),
        type: 'save_up',
        contribution_frequency: 'monthly',
        metadata: { values, monthlysavings: monthlySavings },
        purpose: 'travel',
      };
      dispatch(actions.createGoal(payload));
    }
  };
  const handleInput = values => {
    const updatedvalue = {
      amount: 0,
      years: 0,
      returns: 0,
    };
    if (scenarioFour && budgetExtend !== '') {
      updatedvalue.amount =
        Number(values.amount.substring(1)) - Number(budgetExtend.substring(1));
      if (updatedvalue.amount < 0) {
        updatedvalue.amount = Number(values.amount.substring(1));
      }
    } else {
      updatedvalue.amount = Number(values.amount.substring(1));
    }
    if (scenarioOne && inflation !== '') {
      const percentage = Number(inflation.replace('%', ''));
      const addvalue = Number(
        ((percentage / 100) * Number(values.amount.substring(1))).toFixed(2),
      );
      updatedvalue.amount = Number(values.amount.substring(1)) + addvalue;
    }
    if (
      scenarioFour &&
      scenarioOne &&
      budgetExtend !== '' &&
      inflation !== ''
    ) {
      const percentage = Number(inflation.replace('%', ''));
      const addvalue = Number(
        ((percentage / 100) * Number(values.amount.substring(1))).toFixed(2),
      );
      updatedvalue.amount =
        Number(values.amount.substring(1)) +
        addvalue +
        Number(budgetExtend.substring(1));
      if (updatedvalue.amount < 0) {
        updatedvalue.amount = Number(values.amount.substring(1));
      }
    }
    if (scenarioTwo && timeExtend !== '') {
      updatedvalue.years = Number(timeExtend) / 12 + Number(values.years);
    } else {
      updatedvalue.years = Number(values.years);
    }
    if (scenarioThree && returnExtend !== '') {
      const numericValue = Number(returnExtend.replace('%', ''));
      updatedvalue.returns = Number(numericValue) + Number(values.returns);
    } else {
      updatedvalue.returns = Number(values.returns);
    }

    return updatedvalue;
  };
  const handleSubmit = async () => {
    if (formRef.current) {
      await formRef.current.submitForm();
    } else if (FormRef.current) {
      await FormRef.current.submitForm();
    }
  };

  const formatYearMonths = totalYears => {
    // Separate whole years and remaining months
    const years = Math.floor(totalYears);
    const months = Math.round((totalYears - years) * 12);

    // Construct the string
    if (years === 0) {
      return `${months} ${months !== 1 ? 'Months' : 'Month'}`;
    } else if (months === 0) {
      return `${years} ${years !== 1 ? 'Years' : 'Year'}`;
    } else {
      return `${years} ${years !== 1 ? 'Years' : 'Year'} ${months} ${
        months !== 1 ? 'Months' : 'Month'
      }`;
    }
  };
  const options = [
    { value: 'One-time', label: 'One-time' },
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
  ];
  useEffect(() => {
    if (!Show) {
      setShow(false);
    }
  }, [scenarioTwo, scenarioThree, scenarioFour, Show]);
  useEffect(() => {
    hideNavbar(); // Hide the navbar when this component mounts
    return () => {
      showNavbar(); // Show the navbar again when this component unmounts
    };
  }, [hideNavbar, showNavbar]);
  return (
    <Formik
      innerRef={FormRef}
      initialValues={{
        amount: vacation.budget,
        years: vacation.year,
        returns: vacation.return,
        frequency: vacation.frequency,
      }}
      onSubmit={values => {
        basicSubmit(values);
      }}
    >
      {({ values, handleChange, setFieldValue }) => (
        <Container>
          <Form>
            <Box className="justify-content-start">
              <Arrow
                className="d-flex justify-content-center align-items-center bg-primary rounded-5"
                onClick={() => navigate('/planning')}
              >
                <i
                  className="bi bi-arrow-left-short text-white"
                  style={{
                    fontSize: '20px',
                    color: '#FFFFFF',
                    fontWeight: 700,
                  }}
                ></i>
              </Arrow>
              <Text className="d-flex justify-content-start align-items-center">
                Plan your vacation
              </Text>
            </Box>
            {!switchMode ? (
              <Div>
                <Container1>
                  <CardWrapper>
                    <Card className="flex-column">
                      <Title className="justify-content-between align-items-center">
                        <Text1>Advance planning mode</Text1>
                        <ToggleSwitch>
                          <ToggleInput
                            type="checkbox"
                            checked={switchMode}
                            onChange={() => setswitch()}
                          />
                          <ToggleSlider />
                        </ToggleSwitch>
                      </Title>
                      <Input className="d-flex flex-column align-items-center">
                        <div className="d-flex justify-content-start gap-2 mt-2">
                          <Tag>VACATION BUDGET</Tag>
                          <img src={info} alt="" />
                        </div>
                        <div className="d-flex justify-content-center align-items-center mt-2 w-100">
                          {/* <img src={rupees}/> */}

                          <StyledInput
                            type="text"
                            name="amount"
                            placeholder="0"
                            autoComplete="off"
                            value={values.amount}
                            onChange={e => {
                              let inputValue = e.target.value.replace(
                                /\D/g,
                                '',
                              );
                              if (inputValue) {
                                setFieldValue('amount', '₹' + inputValue);
                                let iv = e.target.value.replace(/\D/g, '');
                                setvacationAmount(iv);
                                setGraphValue(Number(iv));
                              } else {
                                setFieldValue('amount', '');
                                setGraphValue(0);
                              }
                            }}
                          />
                        </div>
                      </Input>
                      <div
                        className="d-flex  justify-content-between align-items-end"
                        style={{ marginTop: '35px' }}
                      >
                        <div className="d-flex  align-items-center justify-content-start gap-2">
                          <InfoText>When do you need the money?</InfoText>
                          <img src={info} alt="" />
                        </div>
                        <Dash className="d-flex justify-content-start gap-2">
                          <InputField
                            type="text"
                            name="years"
                            autoComplete="off"
                            placeholder="0"
                            value={values.years}
                            onChange={e => {
                              setFieldValue('years', e.target.value);
                              setvacationDuration(e.target.value);
                            }}
                            center={true}
                          />
                          <Unit className="d-flex flex-column justify-content-end">
                            yr
                          </Unit>
                        </Dash>
                      </div>
                      <Slider
                        type="range"
                        name="years"
                        value={values.years}
                        onChange={e => {
                          setFieldValue('years', e.target.value);
                          setvacationDuration(e.target.value);
                        }}
                        progress={(Number(values.years) / 100) * 100}
                        min="0"
                        max="100"
                        className="mt-3"
                      />
                      <div className="d-flex justify-content-between mt-0">
                        <Info>1 Year</Info>
                        <Info>100 Years</Info>
                      </div>
                      <div className="d-flex justify-content-between align-items-end mt-5">
                        <div className="d-flex  align-items-center justify-content-start gap-2">
                          <InfoText>Expected ROI</InfoText>
                          <img src={info} alt="" />
                        </div>
                        <Dash className="d-flex justify-content-start gap-2">
                          <InputField
                            type="text"
                            name="returns"
                            autoComplete="off"
                            placeholder="0"
                            value={values.returns}
                            onChange={e => {
                              setFieldValue('returns', e.target.value);
                              setvacationreturns(e.target.value);
                            }}
                            center={true}
                          />
                          <Unit className="d-flex flex-column justify-content-end">
                            %
                          </Unit>
                        </Dash>
                      </div>
                      <Slider
                        type="range"
                        name="returns"
                        value={values.returns}
                        onChange={handleChange}
                        progress={(Number(values.returns) / 100) * 100}
                        min="0"
                        max="100"
                        className="mt-3"
                      />
                      <div className="d-flex justify-content-between mt-0">
                        <Info>1%</Info>
                        <Info>100%</Info>
                      </div>
                      <div className="d-flex justify-content-between mt-5">
                        <div className="d-flex align-items-center justify-content-start gap-2">
                          <InfoText className="align-items-center">
                            Choose the contribution frequency
                          </InfoText>
                          <img src={info} alt="" />
                        </div>
                      </div>
                      <div className="d-flex flex-wrap bg-[#AF8EFF] mt-2 rounded-lg gap-2">
                        {options.map(option => (
                          <Option
                            key={option.value}
                            isSelected={selected === option.value}
                            className="d-flex justify-content-center align-items-center"
                            onClick={() => {
                              setSelected(option.value);
                              if (values.amount !== '' || values.years) {
                                setShow(false);
                              }
                            }}
                          >
                            {option.label}
                          </Option>
                        ))}
                      </div>

                      <Scenario className="d-flex align-items-center justify-content-between mt-4">
                        <Text2>Scenarios</Text2>
                        <Dropdown
                          onClick={() => setOpenScenario(prev => !prev)}
                        >
                          <i
                            className="bi bi-chevron-down text-white"
                            style={{
                              fontSize: '12px',
                              color: '#FFFFFF',
                              fontWeight: 700,
                            }}
                          ></i>
                        </Dropdown>
                      </Scenario>
                      {/* {openScenario && */}
                      <div
                        className={`
                transition-all duration-300 ease-in-out
                ${openScenario ? 'opacity-100' : 'd-none'}
              `}
                      >
                        <Scenarios className="mt-2 justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <ScenarioText>
                              vacation cost inflates by
                            </ScenarioText>
                            <ScenarioQ
                              type="text"
                              placeholder="0"
                              autoComplete="off"
                              value={inflation}
                              onChange={e => {
                                let inputValue = e.target.value.replace(
                                  /\D/g,
                                  '',
                                );
                                if (inputValue) {
                                  setInflation(inputValue + '%');
                                } else {
                                  setInflation('');
                                }
                              }}
                              className="ms-1 me-1"
                            ></ScenarioQ>
                            <ScenarioText>annually</ScenarioText>
                            <img src={info} alt="" className="ms-2" />
                          </div>
                          <ToggleSwitch>
                            <ToggleInput
                              type="checkbox"
                              checked={scenarioOne}
                              onChange={() => {
                                setScenarioOne(prev => !prev);
                                // setShow(true);
                              }}
                            />
                            <ToggleSlider />
                          </ToggleSwitch>
                        </Scenarios>
                        <Scenarios className="justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <ScenarioText>Extend timeline by</ScenarioText>
                            <ScenarioQ
                              type="text"
                              placeholder="0"
                              autoComplete="off"
                              value={timeExtend}
                              onChange={e => setTimeExtend(e.target.value)}
                              className="ms-1 me-1"
                            ></ScenarioQ>
                            <ScenarioText>months</ScenarioText>
                            <img src={info} alt="" className="ms-2" />
                          </div>
                          <ToggleSwitch>
                            <ToggleInput
                              type="checkbox"
                              checked={scenarioTwo}
                              onChange={() => {
                                setScenarioTwo(prev => !prev);
                                // setShow(true);
                              }}
                            />
                            <ToggleSlider />
                          </ToggleSwitch>
                        </Scenarios>
                        <Scenarios className="justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <ScenarioText>Increase ROI by</ScenarioText>
                            <ScenarioQ
                              type="text"
                              placeholder="0"
                              autoComplete="off"
                              value={returnExtend}
                              onChange={e => {
                                let inputValue = e.target.value.replace(
                                  /\D/g,
                                  '',
                                );
                                if (inputValue) {
                                  setReturnExtend(inputValue + '%');
                                } else {
                                  setReturnExtend('');
                                }
                              }}
                              className="ms-1 me-1"
                            ></ScenarioQ>
                            <ScenarioText>
                              to achieve the target faster
                            </ScenarioText>
                            <img src={info} alt="" className="ms-2" />
                          </div>
                          <ToggleSwitch>
                            <ToggleInput
                              type="checkbox"
                              checked={scenarioThree}
                              onChange={() => {
                                setScenarioThree(prev => !prev);
                                // setShow(true);
                              }}
                            />
                            <ToggleSlider />
                          </ToggleSwitch>
                        </Scenarios>
                        <Scenarios
                          className="justify-content-between align-items-center"
                          last
                        >
                          <div className="d-flex align-items-center">
                            <ScenarioText>Reduce budget by </ScenarioText>
                            <ScenarioQ
                              type="text"
                              placeholder="0"
                              autoComplete="off"
                              value={budgetExtend}
                              onChange={e => {
                                let inputValue = e.target.value.replace(
                                  /\D/g,
                                  '',
                                );
                                if (inputValue) {
                                  setBudgetExtend('₹' + inputValue);
                                } else {
                                  setBudgetExtend('');
                                }
                              }}
                              className="ms-1 me-1"
                              budget
                            ></ScenarioQ>
                            <img src={info} alt="" className="ms-2" />
                          </div>
                          <ToggleSwitch>
                            <ToggleInput
                              type="checkbox"
                              checked={scenarioFour}
                              onChange={() => {
                                setScenarioFour(prev => !prev);
                                // setShow(true);
                              }}
                            />
                            <ToggleSlider />
                          </ToggleSwitch>
                        </Scenarios>
                      </div>
                      {/* } */}
                    </Card>
                  </CardWrapper>
                </Container1>

                {Show && (
                  <Container1>
                    <CardWrapper>
                      <Card className="d-flex flex-column" right={true} pl-2>
                        <Text3 className="d-flex justify-content-center align-items-center">
                          Plan your goal
                        </Text3>
                        <Text1 className="mt-2 px-4">
                          Let’s start planning and turn your dreams into reality
                          together!
                        </Text1>
                        <div className="flex justify-center items-center mt-4 w-full">
                          <div className="w-full relative">
                            <img
                              src={Goal}
                              alt="Goal"
                              className="w-full h-auto object-contain max-h-[calc(100vh-200px)] transition-all duration-300"
                              style={{
                                maxWidth: '100%',
                                height: 'auto',
                              }}
                            />
                          </div>
                        </div>
                      </Card>
                    </CardWrapper>
                  </Container1>
                )}
                {/* {!Show && (
              <Card className="flex-column" right={true}>
                <Text1 className="mt-2">
                  The total value of your investment after 6 Years will be
                </Text1>
                <Text className="d-flex justify-content-center align-items-center">
                  ₹ 5,33,015
                </Text>
                <div className="d-flex justify-content-center align-items-center mt-5">
                  <InvestmentPieChart
                  width={400}
                    height={300}
                    values={{
                      amount: values.amount,
                      years: values.years,
                      returns: values.returns,
                      }}
                      />
                      </div>
                      
                      </Card>
                      )} */}
                {!Show && (
                  <Container1>
                    <CardWrapper>
                      <Card className="d-flex flex-column" right={true}>
                        <Text1 className="mt-2 px-4">
                          The total value of your investment after{' '}
                          {formatYearMonths(
                            Number(values.years) +
                              (scenarioTwo ? Number(timeExtend) / 12 : 0),
                          )}{' '}
                          will be
                        </Text1>
                        <Graph className="d-flex justify-content-center align-items-center mt-2">
                          {'₹' + (isNaN(graphValue) ? '0' : graphValue)}
                        </Graph>
                        <div className="d-flex flex-column align-items-center mt-5 px-5">
                          <InvestmentPieChart
                            width={400}
                            height={250}
                            values={handleInput(values)}
                          />
                        </div>

                        <div
                          style={{
                            position: 'absolute',
                            left: '0px',
                            top: '90px',
                          }}
                        >
                          <img
                            src={pic5}
                            alt=""
                            className="w-32 h-32 object-cover"
                          />
                        </div>
                        <div
                          style={{
                            position: 'absolute',
                            right: '3px',
                            bottom: '3px',
                          }}
                        >
                          <img
                            src={pic1}
                            alt=""
                            className="w-32 h-32 object-cover"
                          />
                        </div>
                        <div
                          style={{
                            position: 'absolute',
                            right: '50px',
                            bottom: '3px',
                          }}
                        >
                          <img
                            src={pic2}
                            alt=""
                            className="w-32 h-32 object-cover"
                          />
                        </div>

                        <div
                          className="d-flex flex-column justify-content-center align-items-center w-100 "
                          style={{
                            position: 'absolute',
                            bottom: '90px',
                          }}
                        >
                          <GraphText>
                            You need to save ₹ {monthlySavings} per month to
                            make your plan successful
                          </GraphText>
                          <Tag className="px-5">
                            But you can save ₹ {monthlySavings} per month to be
                            on safer side and make sure that plan for vacation
                            is ON!
                          </Tag>
                        </div>
                      </Card>
                    </CardWrapper>
                  </Container1>
                )}
              </Div>
            ) : (
              <VacationAdvance
                ref={formRef}
                onSubmit={AdvanceSubmit}
              ></VacationAdvance>
            )}
            <div
              className="d-flex justify-content-center align-items-center mt-3"
              onClick={handleSubmit}
            >
              <Button type="button">Start tracking this plan</Button>
            </div>
          </Form>
          {showCongrats &&
            (switchMode ? (
              <CongratsComponent
                boxText={`Save ${advanceVacationData.amount} for vacation`}
                id={id}
              />
            ) : (
              <CongratsComponent
                boxText={`Save ${vacation.budget} for vacation`}
                id={id}
              />
            ))}
        </Container>
      )}
    </Formik>
  );
});
const Graph = styled.h6`
  //styleName: display/d3_x-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 48px;
  font-weight: 800;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Container1 = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  position: relative;
`;
const CardWrapper = styled.div`
  width: 100%;
  height: 100%; // Set explicit height
  display: flex;
  flex-direction: column;
`;
const StyledInput = styled.input`
  border: none;
  outline: none;
  width: auto;
  padding: 0;
  height: 44px;
  font-size: 32px;
  text-align: center;
  background: transparent;
  ::placeholder {
    font-size: 32px;
    color: #838eae;
    text-align: center;
  }
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 45px;
  height: 22px;
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  background-color: #e4e6ec;
  border-radius: 20px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;

  &::before {
    content: '';
    position: absolute;
    height: 16px;
    width: 16px;
    left: 1px;
    right: 1px;
    bottom: 3px;
    background-color: #4c5a81;
    border-radius: 50%;
    transition: transform 0.3s;
  }

  input:checked + & {
    background-color: #c6c0fa;
  }

  input:checked + &::before {
    transform: translateX(26px);
    background-color: #8276f4;
  }
`;
const Dropdown = styled.button.attrs({ type: 'button' })`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #8276f4;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  line-height: 0;
  overflow: hidden;
`;
const InputField = styled.input<{
  width?: string;
  center?: boolean;
  flex?: boolean;
  advance?: boolean;
}>`
  border: none;
  outline: none;
  width: ${props =>
    props.width ? '50%' : props.flex ? '45%' : props.advance ? '65px' : '43px'};
  height: 24px;
  background: #f5f6fa;
  autocomplete: off;
  text-align: ${props => (props.center ? 'right' : 'left')};
  padding-top: ${props => (props.center ? '0px' : '3px')};
  margin: 0;
  font-size: ${props => (props.center ? '24px' : '20px')};
  ::placeholder {
    text-align: ${props => (props.center ? 'right' : 'left')};
    font-size: ${props => (props.center ? '24px' : '20px')};
    color: #838eae;
  }
`;
const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #f5f6fa;
`;
const Button = styled.button`
  height: 52px;
  width: 237px;
  background: #8276f4;
  border-radius: 30px;
  border: 1px #8276f4;
  color: #f3f1fe;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.82px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
const Text3 = styled.h3`
  //styleName: heading/h3_bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Info = styled.div`
  //styleName: body/b11_reg;
  font-family: var(--fontfamilyactivefont);
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
const Slider = styled.input<{ progress?: number }>`
  width: 100%;
  height: 5px;
  border-radius: 18px;
  appearance: none;
  cursor: pointer;
  position: relative;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 10px;
    height: 10px;
    background: #af8eff;
    outline: 3px solid #e4dfff;
    // border: 1px solid #E4DFFF
    border-radius: 50%;
    cursor: pointer;
    margin-top: -0.05rem;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    background: ${props =>
      `linear-gradient(to right, 
        // #5C54AD 0%, 
        #AF8EFF ${props.progress}%,
        #E4DFFF ${props.progress}%, 
        #E4DFFF 100%)`};
    border-radius: 0.5rem;
  }
`;

const Option = styled.div<{ isSelected?: boolean }>`
  background-color: ${props => (props.isSelected ? ' #8276F4' : ' #E4DFFF')};
  color: ${props => (props.isSelected ? '#FFFFFF' : '#8276F4')};
  border-radius: 26px;
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: ${props => (props.isSelected ? '600' : '400')};
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  height: 26px;
  padding: 15px 15px;
`;

const Scenario = styled.div`
  //   border: none;
  border-bottom: 1px solid #c8ccd8;
`;
const Text2 = styled.div`
  //styleName: body/b3_reg;
  font-family: var(--fontfamilyactivefont);
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Unit = styled.h6`
  //styleName: body/b9_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Dash = styled.div<{ advance?: boolean }>`
  width: ${props => (props.advance ? '110px' : '70px')};
  border: none;
  border-bottom: 1px solid #c8ccd8;
  //   padding-left:5px;
  padding-bottom: 5px;
`;
const InfoText = styled.h6`
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: 600;
  bottom: 0;
  left: 0;
  text-align: left;
  color: #22283a;
  margin: 0;
  min-width: fit-content;
`;
const Tag = styled.h6`
  color: #22283a;
  font-family: Nunito;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.37px;
  letter-spacing: 0.1em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;

const Input = styled.div`
  margin-top: 30px; ////changes 12 to 30
  height: 90px;
  gap: 0px;
  border-radius: 15px;
  border: 1px;
  opacity: 0px;
  border: 1px solid #c6c0fa;
  background: #ffffff;
`;
const Text1 = styled.h6`
  //styleName: body/b2_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #22283a;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Title = styled.div`
  display: flex;
`;
const Card = styled.div<{ right?: boolean }>`
  flex: 1;
  margin-top: 28px;
  border-bottom: 1px solid #c8ccd8;
  border-right: ${props => (props.right ? 'none' : '1px solid #C8CCD8')};
  padding-right: ${props => (props.right ? '0px' : '40px')};
  padding-left: ${props => (props.right ? '0px' : '40px')};
  overflow-y: auto;
  position: relative;
  transition: max-height 0.3s ease-in-out;
  ::-webkit-scrollbar {
    width: 0px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent; /* Color of the thumb */
    border-radius: 15px; /* Rounded corners */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #e4dfff; /* Color of thumb when hovered */
  }

  ::-webkit-scrollbar-track {
    background-color: transparent; /* Background color of the track */
    border-radius: 15px; /* Rounded corners of the track */
  }

  ::-webkit-scrollbar-corner {
    background-color: #e4dfff; /* Corner of the scrollbar */
  }
`;
const Div = styled.div`
  display: flex;
  width: 100%;
`;
const Text = styled.h6`
  //styleName: heading/h6_bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  color: #22283a;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Box = styled.div`
  display: flex;
  width: 100%;
  padding-left: 40px;
  padding-top: 20px;
  gap: 20px;
`;
const Arrow = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
const Scenarios = styled.div<{ last?: boolean }>`
  height: 60px;
  width: 100%;
  display: flex;
  border-bottom: ${props => (props.last ? 'none' : '1px solid #E4E6EC')};
`;
const ScenarioText = styled.h6`
  font-family: Nunito;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const ScenarioQ = styled.input<{ budget?: boolean }>`
  height: 20px;
  width: ${props => (props.budget ? '50%' : '40px')};
  border: none;
  border-bottom: 1px solid #e4e6ec;
  outline: none;
  background: transparent;
  autocomplete: off;
  text-align: center;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  ::placeholder {
    text-align: center;
    font-size: 12px;
    color: #838eae;
  }
`;
const GraphText = styled.h6`
  //styleName: body/b2_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 16px;
  font-weight: 700;
  line-height: 27.28px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #5c54ad;
`;
